/**
 * entityUtils — helper per la normalizzazione dei PK delle entità.
 *
 * La pipeline V3 (LangGraph) produce PK con prefisso COD_AZ (es. "GRPCP-E001234").
 * La pipeline V1 produceva PK grezzi ("E001234").
 * Questo helper serve esclusivamente per il **display** — NON usare nelle chiamate
 * API dove il PK con prefisso è necessario per i lookup server-side.
 */

/**
 * Rimuove il prefisso COD_AZ dai PK delle entità.
 * Esempi:
 *   "GRPCP-E001234" → "E001234"
 *   "GRPCP-I005783" → "I005783"
 *   "E001234"       → "E001234"  (no-op)
 *   "NEW"           → "NEW"      (no-op)
 *   null/undefined  → ""
 *
 * Pattern: `^([A-Z]+)-(.+)$` — riconosce qualsiasi prefisso maiuscolo seguito da trattino.
 */
export function stripPkPrefix(pk: string | null | undefined): string {
  if (!pk) return "";
  if (pk === "NEW") return pk;
  const m = pk.match(/^([A-Z]+)-(.+)$/);
  return m ? m[2] : pk;
}
